import React from 'react';

const BUCKET = { muy_favorable: 'favorable', favorable: 'favorable', incierta: 'incierta', desfavorable: 'desfavorable', muy_desfavorable: 'desfavorable' };
const ITEMS = [['favorable', 'favorables', 'text-emerald-300'], ['incierta', 'inciertas', 'text-amber-300'], ['desfavorable', 'desfavorables', 'text-red-300']];

// Latest lawyer evaluation wins; otherwise the approved strategy's qualitative appraisal
export const appraisalOf = (m) => BUCKET[m.latest_evaluation?.valoracion] || BUCKET[m.intake_strategy?.content?.apreciacion] || null;

export const AppraisalSummary = ({ matters }) => {
  const counts = matters.reduce((acc, m) => { const k = appraisalOf(m) || 'sin'; return { ...acc, [k]: (acc[k] || 0) + 1 }; }, {});
  return (
    <div data-testid="crm-appraisal-summary" className="bg-slate-900 rounded-xl p-4 border border-slate-800">
      <p className="flex flex-wrap items-baseline gap-x-3 gap-y-1 text-lg font-bold">
        {ITEMS.map(([k, label, tone]) => <span key={k} data-testid={`crm-appraisal-${k}`} className={tone}>{counts[k] || 0} <span className="text-xs font-normal text-slate-400">{label}</span></span>)}
      </p>
      <p className="text-xs text-slate-400">Apreciación de las causas{counts.sin ? ` · ${counts.sin} sin apreciar` : ''}</p>
    </div>
  );
};
